import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import axios from "axios";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import AuthShell from "@/components/AuthShell";
import { useAuth, formatApiErrorDetail } from "@/lib/AuthContext";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function Login() {
  const { setUser } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    setError("");
    try {
      const { data } = await axios.post(`${API}/auth/login`, { email, password });
      setUser(data);
      navigate("/dashboard");
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail) || err.message);
    } finally {
      setBusy(false);
    }
  };

  return (
    <AuthShell title="Sign in" subtitle="Access your procurement workspace.">
      <form onSubmit={submit} className="space-y-5">
        <div className="space-y-2">
          <Label className="text-xs uppercase tracking-[0.15em] text-slate-500">Email</Label>
          <Input data-testid="login-email-input" type="email" required className="bg-white border-slate-300" value={email} onChange={(e) => setEmail(e.target.value)} />
        </div>
        <div className="space-y-2">
          <div className="flex items-center justify-between">
            <Label className="text-xs uppercase tracking-[0.15em] text-slate-500">Password</Label>
            <Link to="/forgot-password" data-testid="login-forgot-password-link" className="text-xs text-[#0050A0] font-medium hover:text-[#009EDB] transition-colors duration-200">Forgot password?</Link>
          </div>
          <Input data-testid="login-password-input" type="password" required className="bg-white border-slate-300" value={password} onChange={(e) => setPassword(e.target.value)} />
        </div>
        {error && <p className="text-sm text-red-600" data-testid="login-error">{error}</p>}
        <button type="submit" disabled={busy} data-testid="login-submit-btn" className="w-full bg-[#0050A0] text-white py-3.5 text-sm font-semibold hover:bg-[#003F7A] transition-colors duration-200 disabled:opacity-60">
          {busy ? "Signing in…" : "Sign In"}
        </button>
        <p className="text-sm text-slate-500 text-center">
          No account?{" "}
          <Link to="/register" data-testid="login-goto-register-link" className="text-[#0050A0] font-medium hover:text-[#009EDB] transition-colors duration-200">Register</Link>
        </p>
      </form>
    </AuthShell>
  );
}
